// ═══════════════════════════════════════════════════════════════════
//  modules/erp/ItemSprite.js
//  ItemSprite
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { getItemEmoji, itemTextureCandidates } from "./textures";

// <img> avec repli : passe à l'URL suivante en cas d'erreur, et tombe
// sur l'emoji si toutes échouent.
export function ItemSprite({ item, px }) {
  const urls = itemTextureCandidates(item);
  const [idx, setIdx] = useState(0);

  if (idx >= urls.length) {
    return <span style={{ fontSize: Math.round(px * 0.55), lineHeight: 1 }}>{getItemEmoji(item.id)}</span>;
  }
  return (
    <img
      src={urls[idx]}
      alt=""
      draggable={false}
      onError={() => setIdx((i) => i + 1)}
      style={{ width: px * 0.82, height: px * 0.82, imageRendering: "pixelated", objectFit: "contain" }}
    />
  );
}
